export default "/_next/static/images/motley-5f3ea1304b8f5ac6b81fbd47a0fb636f.png";